module.exports = __webpack_public_path__ + "img/fonts.0c999525.svg";